import { render } from "./CaptainTab.vue?vue&type=template&id=512a5b30&scoped=true"
import script from "./CaptainTab.vue?vue&type=script&lang=js"
export * from "./CaptainTab.vue?vue&type=script&lang=js"

import "./CaptainTab.vue?vue&type=style&index=0&id=512a5b30&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512a5b30"]])

export default __exports__